import { ref } from 'vue'
import { defineStore } from 'pinia'
import useConfigurationGlobals from "@/composables/useConfigurationGlobals";

const { $TOKEN, $BASEURL, $APIKEY } = useConfigurationGlobals();

export let useSessionStore = defineStore('sessionStore', () => {
    const apiKey = ref($APIKEY);
    const token = ref($TOKEN);

    async function getToken() {
      if (!apiKey.value) return;
      
      try {
        const response = await fetch(`${$BASEURL}/session/getToken?wf_apikey=${apiKey.value}`);

        if (!response.ok) {
          throw response.status;
        }

        const data = await response.json();

        if (data.status.status_code !== 0 && data.status_code !== 0) {
          throw data.status || data.status_code
        }

        token.value = data.wf_token

        return data
      } catch (error) {
        console.warn(error)
      }           
    }

    // checkToken() for testing only
    async function checkToken() {
      try {
        const response = await fetch(
          `${$BASEURL}/session/checkToken?wf_token=${token.value}`
        )
  
        if (!response.ok) {
          throw response.status;
        }

        const data = await response.json();

        if (data.status.status_code !== 0 && data.status_code !== 0) {
          throw data.status || data.status_code;
        }
        
        return data;
      } catch(error) {
        console.warn(error);
      }      
    }

    return {
      token,
      apiKey,
      getToken,
      checkToken
    }
});
